import { mq, spacing, styled, Text } from '@thg-commerce/gravity-theme'

export const NoResultsFoundContainer = styled.div`
  max-width: ${(props) => props.theme.site.siteWidth};
  margin: 0 auto;
  padding: ${spacing(3)} ${spacing(2)} 0;
  align-items: center;

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    padding: ${spacing(3)} ${spacing(4)} 0;
  }
`

export const Title = styled.h1`
  ${Text('xlarge2', 'alternate')};
  margin: ${spacing(1)} 0 ${spacing(2)} 0;
`

export const Subtitle = styled.p`
  ${Text('bodyText', 'alternate')};
  margin: ${spacing(2)} 0;
  padding-bottom: ${spacing(2)}; ;
`

export const StyledList = styled.ul`
  list-style: disc inside;
  padding-left: 24px;
`

export const StyledListItem = styled.li`
  ${Text('bodyText', 'default')};
`

export const DiscontinuedText = styled.p`
  ${Text('bodyText', 'default')};
  margin: ${spacing(3)} 0;
`

export const SearchContainer = styled.div`
  max-width: 500px;
  margin: ${spacing(3)} 0 ${spacing(4)} 0;
`

export const SearchForm = styled.form`
  display: flex;
  width: 100%;
  height: 40px;
  border: 1px solid ${(props) => props.theme.colors.palette.greys.grey}
  background-color: ${(props) => props.theme.colors.palette.greys.white};
`

export const SearchInput = styled.input`
  ${Text('bodyText', 'default')};
  font-size: 16px;
  flex-grow: 1;
  border: none;
  background: transparent;
  padding: ${spacing(1)};

  &:focus {
    z-index: 1;
    outline: none;
    border-color: ${(props) => props.theme.colors.palette.greys.darker};
  }
`

export const SearchButton = styled.button<{ active?: boolean }>`
  display: flex;
  width: 48px;
  height: 100%;
  justify-content: center;
  align-items: center;

  svg {
    fill: ${(props) => props.theme.colors.palette.brand.base};
  }

  &:focus {
    outline: none;
    outline-offset: -4px;
    ${(props) => `border: 2px solid ${props.theme.colors.palette.brand.base}`};
  }
`

export const HiddenLabel = styled.label`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0px;
  border: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
`
